"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModal = exports.Modal = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactFeather = require("react-feather");

var useModal = function useModal() {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isShowing = _useState2[0],
      setIsShowing = _useState2[1];

  function toggle() {
    setIsShowing(!isShowing);
    /*
    if (!isShowing) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    */
  }

  return {
    isShowing: isShowing,
    toggle: toggle
  };
};

exports.useModal = useModal;

var Modal = function Modal(_ref) {
  var isShowing = _ref.isShowing,
      hide = _ref.hide,
      children = _ref.children;
  return isShowing ? /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-overlay"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-wrapper",
    "aria-modal": true,
    "aria-hidden": true,
    tabIndex: -1,
    role: "dialog"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "modal-close-button",
    "data-dismiss": "modal",
    "aria-label": "Close",
    onClick: hide
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_reactFeather.X, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-container"
  }, children)))), document.body) : null;
};

exports.Modal = Modal;